var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 120","width":_vm.size,"height":_vm.size}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }